import { useSearchParams } from 'next/navigation'
import { useDispatch } from 'react-redux'
import useAppSelector from './useAppSelector'
import { useEffect } from 'react'
import { BOOKING_MEDIUM_LABELS } from 'state/global/constants'
import { setBookingAttribution } from 'state/global/actions'

/**
 * Hook to extract and store `utm_medium` from URL into Redux.
 *
 * - Supports only 'email' and 'sms' values.
 * - Updates Redux state (`bookingAttribution`) if a valid value is found.
 * - Returns the current booking attribution or null if not available.
 */

const useBookingAttribution = (): BookingAttribution => {
  const dispatch = useDispatch()
  const searchParams = useSearchParams()
  const { bookingAttribution } = useAppSelector((state) => state.global)
  const { utmMedium = '' } = bookingAttribution || {}
  const medium = searchParams.get('utm_medium')

  useEffect(() => {
    if (!medium) {
      return
    }

    if (medium in BOOKING_MEDIUM_LABELS) {
      dispatch(
        setBookingAttribution({ utmMedium: BOOKING_MEDIUM_LABELS[medium] })
      )
    }
  }, [medium])

  return utmMedium ? bookingAttribution : null
}

export default useBookingAttribution
